import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if(window.isMobile) return;

        this.from = JSON.parse(this.getData('from'));
        this.to = JSON.parse(this.getData('to'));


        this.tl = new gsap.timeline();
        this.tl.pause();
        this.tl.fromTo(this.el,{
            ...this.from
        }, {
            ...this.to,
            ease: 'none',
            duration: 1
        });
        
    }

    progress(progress) {
        this.tl.progress(progress);
    }
}
